import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tutorialItems: [],
  sessionItems: [],
  totalListedAmount: 0,
  totalSellAmount: 0,
  totalGstAmount: 0,
  payableAmount: 0,
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addTutorialToCart: (state, action) => {
      if (!state.tutorialItems) state.tutorialItems = [];
      const existingItem = state.tutorialItems.find(item => item.tutorialId === action.payload.tutorialId);
      if (!existingItem) {
        state.tutorialItems.push(action.payload);
        state.totalListedAmount = (state.totalListedAmount || 0) + action.payload.price;
        state.totalSellAmount = (state.totalSellAmount || 0) + action.payload.sellingPrice;
        state.totalGstAmount = Math.round(state.totalSellAmount * 0.18);
        state.payableAmount = state.totalSellAmount + state.totalGstAmount;
      }
    },
    addSessionToCart: (state, action) => {
      if (!state.sessionItems) state.sessionItems = [];
      const existingItem = state.sessionItems.find(item => item.sessionId === action.payload.sessionId);
      if (!existingItem) {
        state.sessionItems.push(action.payload);
        state.totalListedAmount = (state.totalListedAmount || 0) + action.payload.price;
        state.totalSellAmount = (state.totalSellAmount || 0) + action.payload.sellingPrice;
        state.totalGstAmount = Math.round(state.totalSellAmount * 0.18);
        state.payableAmount = state.totalSellAmount + state.totalGstAmount;
      }
    },
    removeTutorialFromCart: (state, action) => {
      const item = state.tutorialItems.find(item => item.tutorialId === action.payload);
      if (item) {
        state.totalListedAmount -= item.price;
        state.totalSellAmount -= item.sellingPrice;
        state.tutorialItems = state.tutorialItems.filter(item => item.tutorialId !== action.payload);
        state.totalGstAmount = Math.round(state.totalSellAmount * 0.18);
        state.payableAmount = state.totalSellAmount + state.totalGstAmount;
      }
    },
    removeSessionFromCart: (state, action) => {
      const item = state.sessionItems.find(item => item.sessionId === action.payload);
      if (item) {
        state.totalListedAmount -= item.price;
        state.totalSellAmount -= item.sellingPrice;
        state.sessionItems = state.sessionItems.filter(item => item.sessionId !== action.payload);
        state.totalGstAmount = Math.round(state.totalSellAmount * 0.18);
        state.payableAmount = state.totalSellAmount + state.totalGstAmount;
      }
    },
    clearCart: (state) => {
      state.tutorialItems = [];
      state.sessionItems = [];
      state.totalListedAmount = 0;
      state.totalSellAmount = 0;
      state.totalGstAmount = 0;
      state.payableAmount = 0;
    }
  }
});

export const { addTutorialToCart, addSessionToCart, removeTutorialFromCart, removeSessionFromCart, clearCart } = cartSlice.actions;
export default cartSlice.reducer; 